import script from "./RegisterComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterComponent.vue?vue&type=script&setup=true&lang=js"

import "./RegisterComponent.vue?vue&type=style&index=0&id=7e8619ae&lang=css"

const __exports__ = script;

export default __exports__